"use strict";
// https://medium.com/@parkerjmed/practical-bit-manipulation-in-javascript-bfd9ef6d6c30
Object.defineProperty(exports, "__esModule", { value: true });
exports.UInt8ByteMapCodec = exports.readNumberAtBytePos = exports.setBitsToNumber = void 0;
const debug = false;
/** byte position to use for start and end 87654321 */
const setBitsToNumber = (byte, value, start, end) => {
    const ones = (1 << (end - start + 1)) - 1;
    const mask = ~(ones << (start - 1));
    // reset bits i thru j to one
    byte = byte & mask;
    // shift m by i
    value = value << (start - 1);
    // merge i thru j
    const res = byte | value;
    debug && console.log(Object.fromEntries(Object.entries({ byte, ones, mask, value, res }).map(([k, v]) => [k, v.toString(2)])));
    return res;
};
exports.setBitsToNumber = setBitsToNumber;
/** finds value of mask assuming mask is single set of masked bit positions */
const readNumberAtBytePos = (byte, mask) => {
    let shiftRight = 0;
    let maskClone = mask;
    const max = 10;
    let i = 0;
    while (i < max && (maskClone & 0b1) === 0) {
        maskClone = maskClone >> 1;
        shiftRight++;
        debug && console.log('mask clone', maskClone);
        i++;
    }
    debug && console.log('mask', mask.toString(2));
    debug && console.log('byte', byte.toString(2));
    debug && console.log('shift', shiftRight);
    return (byte >> shiftRight) & (mask >> shiftRight);
};
exports.readNumberAtBytePos = readNumberAtBytePos;
/** a codec to convert a between bitmap and object representation with a constant template with keys in 0x0000, 0x0001, 0x0002 0x0004 ( increasing value ) order as defined in a spefication --
 * Note CORRECT ORDER OF KEYS IN TEMPLATE IS IMPORTANT!
 */
class UInt8ByteMapCodec {
    constructor({ templateMap }) {
        const baseBin = 0b0;
        const expectedLength = 8;
        const actualLength = Object.keys(templateMap).length;
        if (actualLength !== expectedLength) {
            throw new Error(`UInt8ByteMapCodec must have ${expectedLength} keys exactly, got ${actualLength}! Keys: ${Object.keys(templateMap).join(', ')}.`);
        }
        this.extractor = (objectRepresentation) => Object.fromEntries(Object.keys(templateMap).map((k) => [k, objectRepresentation[k] ?? 0]));
        this.decode = ({ int8Bytes }) => Object.fromEntries(Object.keys(templateMap).map((k, i) => [k, int8Bytes & Math.pow(2, i) ? 1 : 0]));
        this.encode = (objectRepresentation) => Object.values(this.extractor(objectRepresentation)).reduce((a, c, i) => (c ? a | Math.pow(2, i) : a), baseBin);
    }
}
exports.UInt8ByteMapCodec = UInt8ByteMapCodec;
